import { Dashboard } from '../dashboard';
import { useDashboardMenu } from './use-dashboard-menu';

export const DashboardMenu = () => {
  const { chartsData, cards } = useDashboardMenu();

  return <Dashboard chartsData={chartsData} cards={cards} />;
};
